/** Partitions all pages (1-indexed) into ordered groups delimited by the cut points. */
export const computeGroups = (numPages, cutAfterSet) => {
  const groups = [];
  if (!numPages) return groups;
  let current = [];
  for (let page = 1; page <= numPages; page++) {
    current.push(page);
    if (cutAfterSet.has(page) || page === numPages) {
      groups.push(current);
      current = [];
    }
  }
  return groups;
};

/** Formats a list of page numbers into a compact label, e.g. [1,2,4] -> "1–2, 4". */
export const formatPageList = (pages) => {
  if (!pages || pages.length === 0) return '';
  const ranges = [];
  let start = pages[0];
  let prev = pages[0];
  for (let i = 1; i < pages.length; i++) {
    if (pages[i] === prev + 1) { prev = pages[i]; continue; }
    ranges.push(start === prev ? `${start}` : `${start}\u2013${prev}`);
    start = pages[i];
    prev = pages[i];
  }
  ranges.push(start === prev ? `${start}` : `${start}\u2013${prev}`);
  return ranges.join(', ');
};

export const formatBytes = (bytes) => {
  if (bytes == null) return '';
  if (bytes < 1000) return `${bytes} B`;
  if (bytes < 1000000) return `${(bytes / 1000).toFixed(1)} KB`;
  return `${(bytes / 1000000).toFixed(2)} MB`;
};
